import { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { EcoModeSection } from './components/EcoModeSection';
import { MonitoredEnvironmentSection } from './components/MonitoredEnvironmentSection';
import { SaveBar } from './components/SaveBar';
import { SchedulesSection } from './components/schedules/SchedulesSection';
import { VentilationSection } from './components/VentilationSection';
import { mobileQuery } from './ds';
import { DamEcoSimplifiedDeviceInfo, DamEcoSimplifiedFormValues } from './types';

const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  font-family: Inter, sans-serif;

  ${mobileQuery} {
    gap: 20px;
  }
`;

interface DamEcoSimplifiedFormProps {
  damId: string;
  device: DamEcoSimplifiedDeviceInfo;
  readOnly: boolean;
  isSaving: boolean;
  onSave: (values: DamEcoSimplifiedFormValues) => void;
  onDiscard: () => void;
}

/** Tela do Modo Eco simplificado, na ordem do design; o estado do formulário vem do `FormProvider` do container. */
export function DamEcoSimplifiedForm({
  damId,
  device,
  readOnly,
  isSaving,
  onSave,
  onDiscard,
}: Readonly<DamEcoSimplifiedFormProps>): ReactElement {
  const { handleSubmit, formState } = useFormContext<DamEcoSimplifiedFormValues>();

  return (
    <FormWrapper onSubmit={handleSubmit(onSave)} noValidate data-testid="eco-simplificado-form">
      <MonitoredEnvironmentSection damId={damId} device={device} readOnly={readOnly} />
      <EcoModeSection readOnly={readOnly} />
      <VentilationSection readOnly={readOnly} />
      <SchedulesSection device={device} readOnly={readOnly} isSaving={isSaving} />
      {!readOnly && formState.isDirty ? <SaveBar isSaving={isSaving} onDiscard={onDiscard} /> : null}
    </FormWrapper>
  );
}
